import React, { useEffect, useState } from "react";
import {
    applyActionCode,
    checkActionCode,
    getCurrentUser
} from "../../../../servises/auth.service";
import LoaderComponent from "../../../components/Loader.component";
import { useHistory } from "react-router-dom";
import userStore from "../../../../stores/user.store";
import { BoxedStyled } from "../../../../style/components/common.styled";
import styled from "styled-components";

const Styles = styled.div`
  text-align: center;
  padding: 30px;
  font-size: 19px;
  line-height: 1.3;
`;

export const completeEmailVerification = async oobCode => {
    const action = await checkActionCode(oobCode);
    if (!action || action.operation !== "VERIFY_EMAIL") {
        throw new Error("Invalid email verification action");
    }

    await applyActionCode(oobCode);
    const firebaseUser = getCurrentUser();
    if (!firebaseUser) {
        throw new Error("Please sign in to verify your email");
    }

    userStore.userToken = await firebaseUser.getIdToken(true);
    await userStore.verifyEmail();
    userStore.emailVerified = true;
};

const VerifyEmail = ({ oobCode }) => {
    const history = useHistory();
    const [loader, setLoader] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        let active = true;

        if (!userStore.logged) {
            history.replace('/login');
            return undefined;
        }

        const verify = async () => {
            try {
                await completeEmailVerification(oobCode);
                if (active) {
                    history.replace("/servers");
                }
            } catch (error) {
                if (active) {
                    userStore.emailVerified = false;
                    setErrorMessage(error.message || "Email verification failed");
                    setLoader(false);
                }
            }
        };

        verify();
        return () => {
            active = false;
        };
    }, [history, oobCode]);

    return (
        <BoxedStyled>
            { loader && (
                <LoaderComponent/>
            ) }

            { !loader && errorMessage && (
                <Styles>{ errorMessage }</Styles>
            ) }

        </BoxedStyled>
    );
};

export default VerifyEmail;
